import { Category } from '@common/types';
import { Box, Card, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import clsx from 'clsx';
import _ from 'lodash';
import { FC } from 'react';
import s from '../StartingRates.module.scss';

type CategorySelectorProps = {
  categories: Category[];
  selectedIndex: number;
  onCategorySelect: (index: number) => void;
};

const CategorySelector: FC<CategorySelectorProps> = ({
  categories,
  selectedIndex,
  onCategorySelect,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      dataHook="categories"
      className={s.categories}
      direction="vertical"
      width="100%"
      gap="18px"
    >
      {_.map(categories, (category, index) => {
        const isSelected = index === selectedIndex;

        return (
          <div
            tabIndex={0}
            key={category.id}
            className={s.categorySelector}
            onClick={() => {
              onCategorySelect(index);
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onCategorySelect(index);
              }
            }}
          >
            <Card
              className={clsx(
                s.categoryRow,
                isSelected && s.selectedCategoryCard,
              )}
            >
              <Card.Header
                title={
                  <Box className={s.categoryBox}>
                    <Text
                      tagName="h3"
                      className={s.headerLabel}
                      weight={isSelected ? 'bold' : 'normal'}
                      size="medium"
                    >
                      {`${t(
                        `explore.services.${category.displayKey}`,
                      )} (${_.size(category.services)})`}
                    </Text>
                  </Box>
                }
              />
            </Card>
          </div>
        );
      })}
    </Box>
  );
};

export default CategorySelector;
